
import {mapActions, mapGetters} from "vuex";
import { assign, pick } from 'lodash'

export default {
    computed: {
        ...mapGetters({

        }),

    },
    methods: {
        ...mapActions({
            decline: 'e/applications/decline',
        }),

        declineApplication(application) {
            return new Promise(resolve => {
                return this.$buefy.dialog.prompt({
                    title: 'Отклонение',
                    message: 'Вы действительно хотите <b>отклонить</b> заявку?<br />',
                    confirmText: 'Отклонить',
                    cancelText: 'Отмена',
                    type: 'is-danger',
                    hasIcon: true,
                    inputAttrs: {
                        placeholder: 'Почему?',
                        maxlength: 250
                    },
                    onConfirm: (value) => {
                        this.decline(assign({}, {comments: value}, pick(application, ['user.id', 'id', 'cpoId']))).then(resolve)
                    }
                })
            })
        },
    },
}
